/*
 * ============================================================
 * SAV_ERP — Smart Account Vision Enterprise Resource Planning
 * Copyright (c) 2026 Hatem Mohamed Abdalla.
 * All rights reserved.
 *
 * This file is part of a proprietary software product owned
 * solely by Hatem Mohamed Abdalla (UAE, +971 50 390 9781).
 * Copying, redistribution, modification, reverse engineering
 * or reuse in any form without prior written consent of the
 * copyright owner is strictly prohibited and will be
 * prosecuted under UAE Federal Law No. 38/2021 on Copyright
 * and applicable international treaties.
 *
 * Fingerprint: SAV-ERP-HMA-2026-#a7f3d0
 * ============================================================
 */
import React from 'react';

/**
 * BranchSelector — Topbar widget (Phase 1c).
 *
 * Renders only when mode ∈ { 'ACTIVE', 'FROZEN' }. In FROZEN we still show
 * the selector because reports & filters must keep working; only *new*
 * document creation is blocked (enforced by the create-flow itself).
 *
 * "All Branches" is a special reporting/browsing option.  Document forms
 * MUST refuse to submit when activeBranchId === 'ALL' and pick a real
 * branch first (each form is expected to render its own guard).
 */
export default function BranchSelector({
  mode,
  branches,
  activeBranchId,
  onChange,
}) {
  if (mode !== 'ACTIVE' && mode !== 'FROZEN') return null;
  const active = activeBranchId || '';
  const isFrozen = mode === 'FROZEN';

  return (
    <div className="flex items-center gap-2" data-testid="topbar-branch-selector">
      <label className="text-xs text-slate-500 hidden sm:inline">الفرع:</label>
      <select
        value={active}
        onChange={(e) => onChange?.(e.target.value)}
        className={
          `text-sm rounded-lg px-2 py-1 border focus:outline-none focus:ring-2 ` +
          `focus:ring-blue-500 ${isFrozen
            ? 'border-amber-300 bg-amber-50 text-amber-800'
            : 'border-slate-300 bg-white text-slate-800'}`
        }
        data-testid="topbar-branch-select"
      >
        {branches.map((b) => (
          <option key={b.id} value={b.id} data-testid={`topbar-branch-option-${b.code}`}>
            {b.is_main ? '🏛️ ' : '📍 '}{b.code} — {b.name_ar || b.name_en}
          </option>
        ))}
        <option value="ALL" data-testid="topbar-branch-option-all">
          🌐 جميع الفروع (استعراض فقط)
        </option>
      </select>
      {isFrozen ? (
        <span
          className="text-[10px] px-1.5 py-0.5 rounded bg-amber-100 text-amber-700 border border-amber-200"
          data-testid="topbar-branch-frozen-badge"
        >
          FROZEN
        </span>
      ) : null}
    </div>
  );
}
